import {
  ConditionsReactivateVideoTutorielDto,
  VideoTutorielRequestDtoProfileEnum,
} from 'lib_api/lib/api/gen';

export type VideoFormValue = {
  profile?: VideoTutorielRequestDtoProfileEnum;
  videoId?: string;
};

export const profilesOptions: VideoTutorielRequestDtoProfileEnum[] = [
  VideoTutorielRequestDtoProfileEnum.AUTORITE_FOURRIERE,
  VideoTutorielRequestDtoProfileEnum.FORCE_DE_L_ORDRE,
  VideoTutorielRequestDtoProfileEnum.GARDIEN_FOURRIERE,
];

export type useChangeValidityVideoTutorielReturn = {
  submitDeprecateVideo: (idCorrelation: string) => Promise<Response>;
  submitReactivateVideo: (idCorrelation: string) => Promise<Response>;
  conditionsReactivateVideo: (
    idCorrelation: string,
  ) => Promise<ConditionsReactivateVideoTutorielDto>;
};

export type FilterDashboardVideoTutoriel = {
  valid?: boolean;
};
